// custom typefaces
require('typeface-noto-sans-kr')
require('typeface-catamaran')

// polyfill
require('intersection-observer')

const metaConfig = require('./gatsby-meta-config')

// 쿼리 파라미터만 변경될 때 Gatsby의 스크롤-상단 이동 방지
// (DSR 계산기 등 URL 파라미터를 활용하는 페이지에서 필요)
exports.shouldUpdateScroll = ({ routerProps: { location }, prevRouterProps }) => {
  if (prevRouterProps) {
    const prev = prevRouterProps.location
    // pathname과 hash가 동일 = 쿼리파라미터만 변경 → 스크롤 유지
    if (prev.pathname === location.pathname && prev.hash === location.hash) {
      return false
    }
  }
  return true
}

exports.onInitialClientRender = () => {
  if (metaConfig.share.facebookAppId) {
    window.fbAsyncInit = function() {
      FB.init({
        appId: metaConfig.share.facebookAppId,
        xfbml: true,
        version: 'v3.2',
      })
      FB.AppEvents.logPageView()
    }
    ;(function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    })(document, 'script', 'facebook-jssdk')
  }
}
